import { render, staticRenderFns } from "./ModalZonification.vue?vue&type=template&id=294472f4&scoped=true"
import script from "./ModalZonification.vue?vue&type=script&lang=ts"
export * from "./ModalZonification.vue?vue&type=script&lang=ts"
import style0 from "./ModalZonification.vue?vue&type=style&index=0&id=294472f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294472f4",
  null
  
)

export default component.exports